"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgMyCollegesSecondary = function SvgMyCollegesSecondary(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement(
            "g",
            { fill: "currentColor", fillRule: "nonzero" },
            _react2.default.createElement("path", { d: "M0 31h10.29v-2.29H.76zM.57 27.75a.58.58 0 00.57.58h9.15v-12H.57v11.42zm5.72-9.14a1.14 1.14 0 011.14-1.14h1.14c.63 0 1.14.51 1.14 1.14v1.72a1.14 1.14 0 01-1.14 1.14H7.43a1.14 1.14 0 01-1.14-1.14v-1.72zm0 5.14c0-.63.51-1.14 1.14-1.14h1.14c.63 0 1.14.51 1.14 1.14V26a1.14 1.14 0 01-1.14 1.14H7.43c-.63 0-1.14-.51-1.14-1.14v-2.25zm-4.58-5.14a1.15 1.15 0 011.15-1.14H4a1.14 1.14 0 011.14 1.14v1.72c0 .63-.51 1.14-1.14 1.14H2.86a1.15 1.15 0 01-1.15-1.14v-1.72zm0 5.14a1.15 1.15 0 011.15-1.14H4c.63 0 1.14.51 1.14 1.14V26A1.14 1.14 0 014 27.18H2.86A1.15 1.15 0 011.71 26v-2.25zM31.24 28.71h-9.53V31H32zM31.43 27.75V16.33h-9.72v12h9.15a.58.58 0 00.57-.58zM25.71 26c0 .63-.51 1.14-1.14 1.14h-1.14c-.63 0-1.14-.51-1.14-1.14v-2.25c0-.63.51-1.14 1.14-1.14h1.14c.63 0 1.14.51 1.14 1.14V26zm0-5.71c0 .63-.51 1.14-1.14 1.14h-1.14c-.63 0-1.14-.51-1.14-1.14v-1.68a1.14 1.14 0 011.14-1.14h1.14c.63 0 1.14.51 1.14 1.14v1.68zM30.29 26a1.15 1.15 0 01-1.15 1.14H28c-.63 0-1.14-.51-1.14-1.14v-2.25c0-.63.51-1.14 1.14-1.14h1.14a1.15 1.15 0 011.15 1.14V26zm0-5.71a1.15 1.15 0 01-1.15 1.14H28c-.63 0-1.14-.51-1.14-1.14v-1.68A1.14 1.14 0 0128 17.47h1.14a1.15 1.15 0 011.15 1.14v1.68zM20.57 31V12.65l-4.57-3-4.57 3V31h1.71v-5.14a2.86 2.86 0 115.72 0V31h1.71zM16 19a3.43 3.43 0 113.43-3.43A3.44 3.44 0 0116 19z" }),
            _react2.default.createElement("path", { d: "M16.34 7.25V5.51h2.3a.33.33 0 00.36-.33V3.5a.34.34 0 00-.34-.33h-2.32V3a.32.32 0 00-.34-.29.32.32 0 00-.32.31v4.22L9.41 11.4l.71.88c5.67-3.76 5.41-3.67 5.88-3.67.47 0 .27 0 5.87 3.67l.72-.89-6.25-4.14z" })
        )
    );
};

exports.default = (0, _withContainer2.default)(SvgMyCollegesSecondary);